import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import '../../table/table.scss';
import { RadioButton } from '../../radio-button/radio-button';
import { GredientInfoIcon } from '../../icons/icons';
import CountIcon from '../../count-card/count-icon';
import UserImage from '../../user-image/user-image';
import getInitials from '../../../helpers/utils';
import { ContractBookingSmallTable } from '../../../schema/bookingColumns';

function ContractedBooking({
  contractList,
  selectedContract,
  setSelectedContract,
}) {
  const [t] = useTranslation('manageorders');
  return (
    <div className="contracted-bookings">
      <h3 className="title">
        {t('manageordersscreen.createbookingmenu.contractedbooking.titlemsg')}
      </h3>
      <div className="custom-table-container">
        <table>
          <thead>
            <tr>
              <th />
              <th />
              <th>
                {t(
                  'manageordersscreen.createbookingmenu.contractedbooking.origin'
                )}
              </th>
              <th>
                {t(
                  'manageordersscreen.createbookingmenu.contractedbooking.destination'
                )}{' '}
              </th>
              <th>
                {t(
                  'manageordersscreen.createbookingmenu.contractedbooking.type'
                )}
              </th>
              <th>
                {t(
                  'manageordersscreen.createbookingmenu.contractedbooking.plant'
                )}
              </th>
              <th>
                {t(
                  'manageordersscreen.createbookingmenu.contractedbooking.equipmenttype'
                )}
              </th>
              <th>
                {t(
                  'manageordersscreen.createbookingmenu.contractedbooking.totalprice'
                )}
              </th>
            </tr>
          </thead>
          <tbody>
            {contractList?.map((contract) => (
              <tr>
                <td>
                  <RadioButton
                    defaultChecked={contract?._id === selectedContract?._id}
                    id={contract?._id}
                    value={contract?._id}
                    name="contracts"
                    onChange={() => {
                      setSelectedContract(contract);
                    }}
                  />
                </td>
                <td>
                  <UserImage
                    removeTooltip
                    path={contract?.forwarderDetails?.forwarder_orgLogo}
                    shortName={getInitials(
                      contract?.forwarderDetails?.forwarderName
                    )}
                  />
                </td>
                <td>{`${contract?.originCity}`}</td>
                <td>{`${contract?.destinationCity}`}</td>
                <td>{`${contract?.type}, ${contract?.region}`}</td>
                <td>{`${contract?.plant}`}</td>
                <td>{`${contract?.equipment}`}</td>
                <td>
                  <div className="d-flex align-center">
                    {contract?.totalUsd
                      ? `${contract?.totalUsd} ${contract?.currency}`
                      : '--'}
                    <CountIcon
                      label={<GredientInfoIcon />}
                      disableBorder
                      disableHover
                      columns={ContractBookingSmallTable()}
                      data={[contract?.priceDetails]}
                      align="center"
                      popoverPlacement="left"
                      enableDynamicTable={true}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ContractedBooking;

ContractedBooking.propTypes = {
  contractList: PropTypes.instanceOf(Array),
  selectedContract: PropTypes.instanceOf(Object),
  setSelectedContract: PropTypes.func,
};

ContractedBooking.defaultProps = {
  contractList: [],
  selectedContract: {},
  setSelectedContract: () => {},
};
